import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types'
import StatisticsByUTMContentComponent from './StatisticsByUTMContent/StatisticsByUTMContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByUTMPage = ({ location, t }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByUTM}</h2>
                </div>
            </div>

            <StatisticsByUTMContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByUTMPage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

export default withRouter(withTranslation(StatisticsByUTMPage));